
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Pantry from "./pages/Pantry";
import Recipes from "./pages/Recipes";
import GroceryList from "./pages/GroceryList";
import Community from "./pages/Community";
import StoreLocator from "./pages/StoreLocator";
import "./index.css";

export default function App() {
  return (
    <BrowserRouter>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/pantry" element={<Pantry />} />
        <Route path="/recipes" element={<Recipes />} />
        <Route path="/grocery" element={<GroceryList />} />
        <Route path="/community" element={<Community />} />
        <Route path="/stores" element={<StoreLocator />} />
      </Routes>
      <Footer />
    </BrowserRouter>
  );
}
